"use client";

import { Link } from "@/i18n/navigation";
import { ArrowRight } from "lucide-react";
import posthog from "posthog-js";

import { Button } from "@/components/ui/button";

export function EmbedPodcastHeroCta() {
  return (
    <Button size="lg" className="group px-8 py-6 text-lg" asChild>
      <Link
        href="/dashboard/create"
        onClick={() =>
          posthog.capture("tool_explore_cta_clicked", {
            surface: "embed_landing",
            destination: "/dashboard/create",
            label: "Generate & embed",
          })
        }
      >
        Generate & embed
        <ArrowRight className="ml-2 w-5 h-5 transition-transform group-hover:translate-x-1" />
      </Link>
    </Button>
  );
}
